import React, { Ref } from 'react';
import { MenuWrapper } from './Menu.styled';

type Position = { top: number; left: number };
interface MenuProps {
  children: React.ReactNode;
  position: Position;
}

export const isHidden = (position: Position) =>
  position.left < 0 && position.top < 0;

export const Menu = React.forwardRef(
  (props: MenuProps, ref: Ref<HTMLDivElement>) => (
    <MenuWrapper
      top={props.position.top}
      left={props.position.left}
      hidden={isHidden(props.position)}
      data-testid="hovering-toolbar"
      aria-hidden={isHidden(props.position)}
      ref={ref}
    >
      {props.children}
    </MenuWrapper>
  )
);
